<script>
import get from 'lodash/get';
import find from 'lodash/find';
import { mapState, mapGetters } from 'vuex';
import VsLogoLoader from 'viralstyle-ui/src/VsLogoLoader';

import clientMixins from 'utils/client-mixins';
import { privileges } from 'domains/base/_base-enum';

export default {
  components: {
    VsLogoLoader,
  },
  mixins: [clientMixins],
  data: () => ({
    ready: false,
  }),
  computed: {
    ...mapState({
      processing: state => state.processing,
      currentUser: state => state.currentUser,
      domains: state => state.whitelabel.domains,
    }),
    ...mapGetters([
      'permissionAccessDomains',
      'activeDomainsCount',
    ]),
  },
  beforeRouteUpdate(to, from, next) {
    this.$_redirect(to, from, next);
  },
  created() {
    this.$_redirect(this.$route);
  },
  methods: {
    $_redirect(to, from, next) {
      if (!this.permissionAccessDomains || this.currentUser.max_domains_allowed === 0) {
        this.$router.replace({ name: 'home' });
      } else {

        switch (to.name) {
          case 'domains':
            this.$_domainsRootRedirect();

            break;

          case 'domainsRegister':
            if (this.currentUser.max_domains_allowed && this.activeDomainsCount >= this.currentUser.max_domains_allowed) {
              this.$_domainsRootRedirect();
            } else {
              if (next) {
                next();
              }
            }

            break;

          case 'domainsList':
            this.$_domainsRootRedirect(next);

            break;

          case 'domainsCreate':
            if (!from || from.name !== 'domainsRegister') {
              this.$router.replace({ name: 'domainsRegister' });
            } else {
              if (next) {
                next();
              }
            }

            break;

          case 'domainsEdit':
            if (find(this.domains, domain => domain.domain_id === to.params.domainId)) {
              if (next) {
                next();
              }
            } else {
              this.$_domainsRootRedirect();
            }

            break;

          default:
            if (next) {
              next();
            }

            break;
        }
      }
    },
    $_domainsRootRedirect(next) {
      if (!this.hasWhitelabelDomain) {
        this.$router.replace({ name: 'domainsRegister' });
      } else if (this.currentUser.max_domains_allowed === 1) {
        let activeDomain = find(this.domains, domain => domain.active);

        if (activeDomain && this.domains.length === 1) {
          this.$router.replace({ name: 'domainsEdit', params: { domainId: activeDomain.domain_id } });
        } else {
          if (next) {
            next();
          } else {
            this.$router.replace({ name: 'domainsList' });
          }
        }
      } else {
        if (next) {
          next();
        } else {
          this.$router.replace({ name: 'domainsList' });
        }
      }
    },
  },
};
</script>

<template lang='pug'>
.whitelabel
  router-view
</template>

<style>
@import '~import/index';
@import '~styles/index';

.whitelabel {
  @extend %content-margin;
}
</style>